// lib
import React from "react";
// src
import Favorites from "containers/modals/favorites/Favorites";
import Search from "containers/modals/search/Search";

const Modals = () => (
  <>
    <Favorites />
    <Search />
  </>
);

export default Modals;
